/* PLAGARY: one-tab list -> exact product -> list return, no analytics or server state. */
(() => {
  'use strict';
  if (window.__plagaryBrowseContext) return;
  window.__plagaryBrowseContext = true;
  const node = document.getElementById('cf-routes');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const root = new URL(config.root, location.origin).pathname.replace(/\/?$/, '/');
  const PENDING = 'plagary:browse-pending:v1', RESTORE = 'plagary:browse-restore:v1';
  const STATE = 'plagaryBrowseV1', MAX_AGE = 30 * 60 * 1000;
  const isList = !!document.querySelector('.collection-page,.search-page');
  const productSection = document.querySelector('[data-product-section]');
  if (!isList && !productSection) return;

  function route(url) {
    if (url.origin !== location.origin || url.username || url.password || !url.pathname.startsWith(root)) return null;
    return url.pathname.slice(root.length);
  }
  function listURL(value) {
    try {
      const url = new URL(value, location.origin), path = route(url);
      if (!path || !(/^(?:collections\/[^/]+\/?|search\/?)$/.test(path))) return null;
      const clean = new URL(url.pathname, location.origin);
      for (const [key, value] of url.searchParams) {
        if (['q','type','sort_by','page','options[prefix]'].includes(key) || /^filter\.[\w.\[\]-]+$/.test(key)) clean.searchParams.append(key, value);
      }
      clean.searchParams.sort();
      if (clean.href.length > 4096) return null;
      return clean;
    } catch { return null; }
  }
  function productKey(value) {
    try {
      const path = route(new URL(value, location.origin));
      const match = path?.match(/^(?:collections\/[^/]+\/)?products\/([^/]+)\/?$/);
      if (!match) return null;
      const key = decodeURIComponent(match[1]);
      return key.length <= 255 && !/[\/#?]/.test(key) ? key : null;
    } catch { return null; }
  }
  function get(key) {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; }
  }
  function remove(key) { try { sessionStorage.removeItem(key); } catch { /* Native links remain usable. */ } }
  function put(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; }
  }
  function fresh(value, age = MAX_AGE) {
    return value?.v === 1 && Number.isSafeInteger(value.at) && Date.now() >= value.at && Date.now() - value.at <= age &&
      Number.isFinite(value.y) && value.y >= 0 && value.y <= 10000000 && typeof value.product === 'string' && !!listURL(value.from);
  }
  function state(value) {
    const previous = history.state && typeof history.state === 'object' ? {...history.state} : {};
    if (value) previous[STATE] = value; else delete previous[STATE];
    history.replaceState(previous, '', location.href);
  }
  function ordinaryClick(event, link) {
    return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
      !event.defaultPrevented && (!link.target || link.target === '_self') && !link.hasAttribute('download');
  }
  function restoreList() {
    if (!isList) return;
    // Read once; a non-matching page must not keep a stale return request alive.
    const restore = get(RESTORE); remove(RESTORE); remove(PENDING);
    const here = listURL(location.href), referrerKey = productKey(document.referrer);
    if (!fresh(restore, 60 * 1000) || !here || listURL(restore.from)?.href !== here.href || referrerKey !== restore.product) return;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const element = document.documentElement, previous = element.style.scrollBehavior;
      element.style.scrollBehavior = 'auto';
      window.scrollTo(0, Math.min(restore.y, Math.max(0, element.scrollHeight - innerHeight)));
      requestAnimationFrame(() => { element.style.scrollBehavior = previous; });
    }));
  }

  let context = null;
  if (productSection) {
    const key = productKey(location.href), pending = get(PENDING); remove(PENDING);
    const referrer = listURL(document.referrer);
    if (fresh(pending, 60 * 1000) && pending.product === key && referrer?.href === listURL(pending.from)?.href) context = pending;
    const retained = history.state?.[STATE];
    if (!context && fresh(retained) && retained.product === key) context = retained;
    state(context);
    if (context) {
      let back = productSection.querySelector('[data-browse-back]');
      if (!back) {
        back = document.createElement('a'); back.className = 'text-link product-back';
        back.setAttribute('data-browse-back', '');
        productSection.insertBefore(back, productSection.querySelector('.product-layout'));
      }
      const destination = listURL(context.from);
      back.href = destination.href;
      if (route(destination).replace(/\/$/, '') === 'search') back.textContent = 'Back to search results';
      else if (!back.textContent.trim()) back.textContent = 'Back to all objects';
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link || !ordinaryClick(event, link)) return;
    if (isList && link.closest('.product-card')) {
      const from = listURL(location.href), key = productKey(link.href);
      if (!from || !key) return;
      put(PENDING, {v:1, at:Date.now(), from:from.href, y:scrollY, product:key});
    } else if (context && link.hasAttribute('data-browse-back')) {
      const destination = listURL(link.href);
      if (!fresh(context) || !destination || destination.href !== listURL(context.from)?.href) return;
      put(RESTORE, {...context, at:Date.now()});
    }
  });
  restoreList();
  window.addEventListener('pageshow', restoreList);
})();
